import { ReactNode } from 'react';
import { FormApi } from 'final-form';
import { IApiResponse } from 'utils/models';

export const sortArrays = ['Source Account:', 'Destination Account:', 'Narration:', 'Amount:'];

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  numberOfTransactions: 'Number of Transactions:',
  totalAmount: 'Total Amount:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of Transactions:',
  'Total Amount:',
];

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const warnings = {
  MAX_BULK_TRANSFERS: 'You have reached the maximum(10) number of transfers.',
  SAME_ACCOUNT: 'The destination account should not be same as source account.',
  ACCOUNT_NOT_VERIFIED: 'The destination account was not verified.',
  ENTER_NON_INSTANT_BEN: 'You should enter the beneficiary name.',
};

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
}

export interface IFormValues {
  sourceAccount: string;
  amount: string;
  destinationAccountNo: string;
  narration: string;
  pin?: string;
  files: fileUpload[];
}

type fileUpload = {
  name: string;
  size: number;
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IBulkUploadData extends IApiResponse {
  bulkUploadData: IBulkDataList[]
}

export interface IBulkDataList {
  amount: string,
  cardLastDigit: number,
  narration: string,
  beneficiaryAccount: string,
  customerId: string,
  phoneNumber: string,
  cardName: string,
  beneficiaryName: string;
  description: string
  sourceAccount: string,
  code: number,
}

export type BankTypeKeys = 'INSTANT' | 'NON_INSTANT';

export interface IFormCommonFields {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
}

export interface IBulkCommonFields extends IFormCommonFields, IExtraFields {
  currencyCode: string;
  saveBen: boolean;
  transferType?: BankTypeKeys;
}

export type IBulkStatusModalP = {
  open: boolean;
  status: 'success' | 'failure';
  content: React.ReactChild;
}

export interface IBulkCardData
  extends Pick<
    IBulkCommonFields,
    'amount' | 'destinationAccountNo' | 'sourceAccount' | 'narration' | 'destinationAccountName' | 'transferType'
  > {
  destinationBankName?: string;
  transactionCharge?: string | number;
}
